<template>
<div class="chapter">
<div class="inner_page">
<div class="Parts-11">
<p class="Title-page-title-1">Mary &amp; Me</p>
<p class="Title-page-subtitle">A LASTING LINK THROUGH INK</p>
<p class="Guest-essay-7">MARY POTTER KENYON &amp; MARY JEDLICKA HUMSTON</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00.2_MaryMe.vue?35b5050c